import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "pane"]

  select(event) {
    event.preventDefault()
    const link = event.currentTarget
    this.#activate(link.dataset.tab)
    history.replaceState(history.state, "", link.href)
  }

  #activate(tabName) {
    this.tabTargets.forEach(t => {
      const selected = t.dataset.tab === tabName
      t.setAttribute("aria-selected", selected)
    })

    this.paneTargets.forEach(p => {
      p.hidden = p.dataset.tab !== tabName
    })
  }
}
